import { useState } from "react";
import { ChevronDown, Handshake, Wallet } from "lucide-react";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuLabel, DropdownMenuSeparator, DropdownMenuTrigger } from "@/components/ui/dropdown-menu";
import { api, apiError } from "@/lib/api";
import { METHOD_ACCOUNT, METHODS, useAccounts } from "@/lib/finance";
import CollectionDialog from "@/components/finance/CollectionDialog";
import PromiseDialog from "@/components/finance/PromiseDialog";

const LABEL = { nakit: "Kasa (Nakit)", havale: "Banka (Havale/EFT)", kart: "Kredi Kartı / POS", cek: "Çek", senet: "Senet" };

async function openAmount(o) {
  if (o.invoice_no) {
    try {
      const { data } = await api.get(`/customers/${o.customer_id}/open-invoices`);
      const it = data.items.find((x) => x.doc_no === o.invoice_no);
      if (it) return it.remaining;
    } catch { /* yetki yoksa vadeli kısım */ }
  }
  return o.deferred_amount_try || 0;
}

// "Tahsilat Yap ▾": mevcut tahsilat türleri (hesabı tanımlı olanlar) → mevcut tahsilat formu, bu siparişin carisi/açık tutarı/notuyla dolu.
export default function CollectionMenu({ o, onDone, onPromise }) {
  const accounts = useAccounts();
  const [dlg, setDlg] = useState(null);
  const [soz, setSoz] = useState(null);
  const types = Object.keys(METHODS).filter((k) => !METHOD_ACCOUNT[k] || accounts.some((a) => a.type === METHOD_ACCOUNT[k]));
  const load = async () => {
    const [{ data: c }, amount] = await Promise.all([api.get(`/customers/${o.customer_id}`), openAmount(o)]);
    return { amount: Math.round(amount * 100) / 100, customer: { id: c.id, title: c.title, code: c.code, balance: c.balance } };
  };
  const start = async (method) => { try { setDlg({ method, ...(await load()) }); } catch (e) { toast.error(apiError(e)); } };
  const promise = async () => { try { setSoz(await load()); } catch (e) { toast.error(apiError(e)); } };
  return (
    <>
      <DropdownMenu modal={false}>
        <DropdownMenuTrigger asChild><Button size="sm" variant="outline" className="text-blue-700 border-blue-300" data-testid="collection-menu-button"><Wallet className="h-4 w-4 mr-1" />Tahsilat Yap<ChevronDown className="h-3.5 w-3.5 ml-1" /></Button></DropdownMenuTrigger>
        <DropdownMenuContent align="end" className="w-56" data-testid="collection-menu">
          {accounts.length === 0 && <DropdownMenuLabel className="text-xs text-slate-400">Yükleniyor…</DropdownMenuLabel>}
          {accounts.length > 0 && types.map((k) => <DropdownMenuItem key={k} onSelect={() => start(k)} data-testid={`collection-menu-${k}`}>{LABEL[k]}</DropdownMenuItem>)}
          <DropdownMenuSeparator />
          <DropdownMenuItem onSelect={promise} className="text-amber-800" data-testid="collection-menu-promise"><Handshake className="h-4 w-4 mr-2" />Ödeme Sözü</DropdownMenuItem>
        </DropdownMenuContent>
      </DropdownMenu>
      {soz && <PromiseDialog customer={soz.customer} order={o} initialAmount={soz.amount || ""} onClose={() => setSoz(null)} onDone={() => { setSoz(null); onPromise?.(); }} />}
      {dlg && <CollectionDialog customer={dlg.customer} initialMethod={dlg.method} initialAmount={dlg.amount || ""}
        initialNote={`Sipariş ${o.order_no}${o.invoice_no ? ` · Fatura ${o.invoice_no}` : ""}`}
        onClose={() => setDlg(null)} onDone={() => { setDlg(null); onDone?.(); }} />}
    </>
  );
}
